import { render, staticRenderFns } from "./updateticket.vue?vue&type=template&id=226e1b78&"
import script from "./updateticket.vue?vue&type=script&lang=js&"
export * from "./updateticket.vue?vue&type=script&lang=js&"
import style0 from "./updateticket.vue?vue&type=style&index=0&id=226e1b78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports